// extracted by mini-css-extract-plugin
export var clipStar = "style-mod--clip-star--6adef";
export var productStars = "style-mod--product-stars--16b0b";
export var ratingText = "style-mod--rating-text--87261";